import { css } from '@emotion/react';
import { fadeIn } from '@/styles/keyframes';
import { getScreen } from '@/styles/media-query';
import { Faq } from '@/types/cms-types';

export type FaqCardProps = {
  className?: string;
} & Faq;

export const FaqCard: React.FC<FaqCardProps> = ({
  className,
  question,
  answer,
}) => {
  return (
    <details
      css={css`
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.17);
        color: #5a5b6a;
        font-size: 1.4rem;
        text-align: left;

        @media ${getScreen('pc')} {
          font-size: 1.6rem;
        }
      `}
      className={className}
    >
      <summary
        css={css`
          outline: none;
          display: grid;
          grid-template-columns: 58px 1fr 32px;
          align-items: center;
          min-height: 92px;
          padding: 18px 20px;

          @media ${getScreen('pc')} {
            grid-template-columns: 75px 1fr 32px;
            min-height: 104px;
            padding: 24px 26px;
          }

          &::before {
            content: 'Q';
            padding-top: 2px;
            padding-left: 11px;
            font: normal normal bold 26px/36px 'Noto Sans JP', sans-serif;
            letter-spacing: 0px;
            color: #ffffff;
            width: 43px;
            height: 43px;
            background: linear-gradient(180deg, #00b3a7 0%, #00c9be 100%);
            border-radius: 50%;
          }

          &::-webkit-details-marker {
            display: none;
          }
        `}
      >
        <p>{question}</p>
        <p
          css={css`
            font-size: 3.1rem;
            color: #00b3a7;
            display: inline-block;
            width: 32px;
            line-height: 43px;
            transition: transform 0.3s ease;

            @media ${getScreen('pc')} {
              line-height: initial;
            }

            [open] & {
              transform: rotate(45deg);
            }
          `}
          aria-label="開く"
        >
          ＋
        </p>
      </summary>
      <div
        css={css`
          padding: 12px 20px 20px;
          position: relative;

          @media ${getScreen('pc')} {
            padding: 20px 26px;
          }

          [open] & {
            animation: ${fadeIn} 0.3s ease both;
          }

          &::before {
            content: '';
            display: block;
            width: auto;
            height: 1px;
            background: #c5c5d1;
            position: absolute;
            top: 0;
            right: 20px;
            left: 20px;

            @media ${getScreen('pc')} {
              right: 26px;
              left: 26px;
            }
          }
        `}
      >
        <div
          css={css`
            margin-left: 18px;

            @media ${getScreen('pc')} {
              margin-left: 76px;
            }

            ul {
              list-style: disc;
            }
          `}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </div>
    </details>
  );
};
